import { useEffect, useState } from 'react';
import { getUser } from '../api';
import { UserEmail } from '../types';

/**
 * @name useUserData
 * @description if authenticated, gets the current user via
 * the API on mount and returns the user object.
 * @param isAuthenticated {boolean} determining if the user is authenticated
 */
export const useUserData = (isAuthenticated?: boolean | undefined) => {
    const [userData, setUserData] = useState<any>({});

    useEffect(() => {
        if (isAuthenticated) {
            const getUserData = async () => {
                try {
                    const userData = await getUser();
                    setUserData(userData);
                } catch {
                    // expect failure if user isn't logged in
                    // and handle within calling function
                }
            };

            getUserData();
        }
    }, [isAuthenticated]);

    return {
        ...userData,
        primaryEmail:
            userData?.emails?.find((email: UserEmail) => email.primary === true)
                .email || '',
    };
};
